// shared/pdf/components/PdfTable.jsx
import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const ROW_H = 16;

const base = StyleSheet.create({
  headRow:  { flexDirection: 'row', minHeight: ROW_H },
  bodyRow:  { flexDirection: 'row', minHeight: ROW_H },
  footRow:  { flexDirection: 'row', minHeight: ROW_H + 2 },
  cell:     { paddingHorizontal: 4, paddingVertical: 3, fontSize: 8, fontFamily: 'NotoSans', overflow: 'hidden' },
  headCell: { paddingHorizontal: 4, paddingVertical: 3, fontSize: 7.5, fontFamily: 'NotoSans', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 0.5 },
  footCell: { paddingHorizontal: 4, paddingVertical: 4, fontSize: 8.5, fontFamily: 'NotoSans', fontWeight: 'bold' },
});

// cols: [{ label, flex?, width?, align? }]
// values: string[]
export function PdfTableHead({ cols, theme }) {
  return (
    <View style={[base.headRow, { backgroundColor: theme.dark, borderBottomWidth: theme.rule ? 0.5 : 0, borderBottomColor: theme.rule || 'transparent' }]} wrap={false}>
      {cols.map((col, i) => (
        <Text
          key={i}
          style={[base.headCell, { flex: col.flex || 1, width: col.width, textAlign: col.align || 'left', color: theme.headerText }]}
        >
          {col.label}
        </Text>
      ))}
    </View>
  );
}

export function PdfTableRow({ cols, values, index, theme, highlight }) {
  const bg = highlight === 'danger'  ? theme.mid
           : highlight === 'success' ? theme.light
           : index % 2 === 0 ? theme.white : theme.light;
  return (
    <View style={[base.bodyRow, { backgroundColor: bg, borderBottomWidth: theme.rule ? 0.3 : 0, borderBottomColor: theme.rule || 'transparent' }]} wrap={false}>
      {cols.map((col, i) => (
        <Text
          key={i}
          style={[base.cell, { flex: col.flex || 1, width: col.width, textAlign: col.align || 'left', color: col.color || theme.body }]}
        >
          {String(values[i] ?? '—')}
        </Text>
      ))}
    </View>
  );
}

export function PdfTableFoot({ cols, values, theme }) {
  return (
    <View style={[base.footRow, { backgroundColor: theme.mid, borderTopWidth: theme.rule ? 0.5 : 0, borderTopColor: theme.rule || 'transparent' }]} wrap={false}>
      {cols.map((col, i) => (
        <Text
          key={i}
          style={[base.footCell, { flex: col.flex || 1, width: col.width, textAlign: col.align || 'left', color: theme.body }]}
        >
          {String(values[i] ?? '')}
        </Text>
      ))}
    </View>
  );
}
